/**
 * Tooltip Plugin
 *
 * this is a wrapper for jquery ui's tooltip plugin, it sets some default configuration options, which
 * can be overwritten, and allows tooltip's public method's to be called (ie. open, close..)
 *
 * to set tooltip content, include a 'data-content' attribute on triggering element, containing
 * html/text or a jquery selector pointing to a wrapper containing content. to set content dynamically,
 * pass a content function to the config
 *  ie. $(...).dibsTooltip({content: function() { return 'dynamically added content' }});
 *
 *  currently used here:
 *  js/checkout/subviews/CheckoutSubmitButton.js
 *  js/global/modules/commonjs/dibsTooltips.js (being required by other files)
 *
 */
'use strict';

var $ = require('dibs-jquery-shim');
var mobileCheck = require('bunsen/helpers/mobileCheck');
var clickedClass = 'is-clicked';
var hoverClass = 'is-hover';
var fadeDuration = 300;
var viewportSpacer = 4;

var init;
var rePosition;
var fetchContent;
var handleClose;
var handleClick;
var checkDisabled;
var _open;
var _close;

require('bunsen/thirdParty/jquery-ui/1.10.x/jquery.ui.core');
require('bunsen/thirdParty/jquery-ui/1.10.x/jquery.ui.widget');
require('bunsen/thirdParty/jquery-ui/1.10.x/jquery.ui.position');
require('bunsen/thirdParty/jquery-ui/1.10.x/jquery.ui.tooltip');

init = function(options) {
    var $self = $(this);
    var defaults = {
        position: {
            // position horizontally-centered, above trigger
            my: 'center bottom-20',
            at: 'center top',
            // if cannot fit, display underneath trigger
            collision: 'flipfit',
            using: rePosition,
        },
        content: fetchContent,
        close: handleClose,
        items: '*',
        show: fadeDuration,
        hide: fadeDuration,
        showArrow: true,
        allwaysRepositionArrow: false,
    };
    if (options && options.isConfirmation) {
        $.extend(true, defaults, {
            position: {
                my: 'center bottom-15',
            },
            closeDelay: 3000,
            disabled: true,
            showArrow: false,
        });
        // do not hide confirmation on mouseout of trigger
        $self.on('mouseout', function(event) {
            event.stopImmediatePropagation();
        });
    }
    options = $.extend(true, {}, defaults, options);
    handleClick($self);
    $self.tooltip(options);
    // always set tooltip class to 'dibstooltip', allow additional classes from trigger's data-tooltipclass or config
    $self.each(function() {
        var $this = $(this);
        var tooltipClass = $this.tooltip('option', 'tooltipClass');
        tooltipClass =
            'dibstooltip' +
            (options.isConfirmation ? ' is-confirmation' : '') +
            ($this.data('tooltipclass') ? ' ' + $this.data('tooltipclass') : '') +
            (tooltipClass ? ' ' + tooltipClass : '');
        $this.tooltip('option', 'tooltipClass', tooltipClass);
    });
    return $self;
};

_open = function() {
    var $this = $(this);
    // for confirmation tooltips, auto close after closeDelay, unless mouseenter
    if ($this.tooltip('option', 'isConfirmation')) {
        clearTimeout($this.timeout);
        $this.timeout = setTimeout(function() {
            if ($this.length > 0) {
                // if length === 0, then it's the `document`
                // and does not have a valid element to "close"
                close.call($this);
            }
        }, $this.tooltip('option', 'closeDelay'));
        $this.one('tooltipopen', function(event, ui) {
            ui.tooltip.hover(
                function() {
                    clearTimeout($this.timeout);
                },
                function() {
                    if ($this.length > 0) {
                        // if length === 0, then it's the `document`
                        // and does not have a valid element to "close"
                        close.call($this);
                    }
                }
            );
        });
    }
    return $this.tooltip('open');
};

_close = function() {
    return $(this)
        .removeClass(clickedClass + ' ' + hoverClass)
        .tooltip('close');
};

rePosition = function(newPosition, info) {
    var $this = $(this);
    var triangle;
    var pointLocation;
    var allwaysRepositionArrow;
    // adjust so that tooltip is not on viewport edge
    if (info.element.left + info.element.width >= $(window).width()) {
        info.element.left -= viewportSpacer;
    } else if (info.element.left <= 0) {
        info.element.left = viewportSpacer;
    }
    // always show over modal
    if ($('.modal-bg:visible').length) {
        $this.addClass('is-modal-open');
    }
    // position tooltip
    $this.css({
        left: info.element.left + 'px',
        top: info.element.top + 'px',
    });

    if (info.target.element.tooltip('option', 'showArrow')) {
        allwaysRepositionArrow = info.target.element.tooltip('option', 'allwaysRepositionArrow');
        triangle = $("<div class='dibstooltip-triangle'></div>");
        // add above/below class to triangle depending on position
        triangle.addClass(info.element.top > info.target.top ? 'below' : 'above');
        // triangle is in the middle of tooltip by default, if tooltip has been shifted horizontally to
        // fit within viewport, need to reposition triangle to point at trigger
        pointLocation = info.element.left + info.element.width / 2;
        if (
            allwaysRepositionArrow ||
            pointLocation < info.target.left ||
            pointLocation > info.target.left + info.target.width
        ) {
            triangle.css(
                'left',
                info.target.left - info.element.left + info.target.width / 2 + 'px'
            );
        }
        $this.append(triangle);
    }
};

// set content from data-content attribute, allow selector or string
fetchContent = function() {
    var content = $(this).data('content') || '';
    var element;
    try {
        element = $('#' + content);
    } catch (err) {
        /* swallow the exception */
    }
    return element && element.length ? element.html() : content;
};

// keep open when hovering over tooltip
handleClose = function(e, ui) {
    ui.tooltip.hover(
        function() {
            $(this)
                .stop(true)
                .fadeTo(fadeDuration, 1);
        },
        function() {
            var $this = $(this);
            $this.fadeOut(fadeDuration, $this.remove);
        }
    );
};

// keep tooltip open on click, close with another click
handleClick = function(elements) {
    var toggleTooltip = function() {
        var $this = $(this);
        $this.toggleClass(clickedClass).tooltip($this.hasClass(clickedClass) ? 'open' : 'close');
    };
    // ios - disable normal tooltip events, fire manually via mousedown
    if (mobileCheck.iOS()) {
        elements.bind({
            'mouseover focusin mouseleave focusout click': function(e) {
                if (!checkDisabled.apply($(this))) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                }
            },
            mousedown: function() {
                var $tooltip = $(this);
                if (!checkDisabled.apply($tooltip)) {
                    toggleTooltip.apply($tooltip);
                }
            },
        });
    } else {
        // non-ios - keep open on click, prevent from closing on mouseleave
        // add hover classes dynamically to avoid ios :hover issues
        elements
            .bind({
                click: function(e) {
                    var $tooltip = $(this);
                    if (!checkDisabled.apply($tooltip)) {
                        e.preventDefault();
                        toggleTooltip.apply($tooltip);
                    }
                },
                mouseleave: function(e) {
                    if ($(this).hasClass(clickedClass)) {
                        e.stopImmediatePropagation();
                    }
                },
            })
            .hover(
                function() {
                    $(this).addClass(hoverClass);
                },
                function() {
                    $(this).removeClass(hoverClass);
                }
            );
    }
};

checkDisabled = function() {
    return this.dibsTooltip('option', 'disabled');
};

$.fn.dibsTooltip = function(method) {
    // allow public methods of tooltip to be called
    if ($.inArray(method, ['destroy', 'disable', 'enable', 'option', 'widget']) > -1) {
        return this.tooltip.apply(this, arguments);
    }
    // init with config options
    if (typeof method === 'object' || !method) {
        return init.call(this, method);
    }
    if (method === 'open') {
        return _open.call(this);
    }
    if (method === 'close') {
        return _close.call(this);
    }
    $.error('Method ' + method + ' does not exist on jQuery.dibsTooltip');
    return this;
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/plugins/dibs-tooltip.js
// module id = 2111
// module chunks = 62